import LayoutPage from '@/components(new)/layout/LayoutBases/LayoutAnalise/LayoutAnalise.vue'
import menuOptions from '@/libs/constants/painel/sala-monitoramento/menu.js'
import { items } from './routes'

const cadastro = [
  {
    path: '/sala-monitoramento',
    name: 'sala-monitoramento',
    component: LayoutPage,
    props: {
      menuOptions: menuOptions
    },
    redirect: '/sala-monitoramento/caixa-entrada',
    children: [...items]
  }
]

export default cadastro



// WEBPACK FOOTER //
// ./src/router/sala-monitoramento/index.js